module.exports = __webpack_public_path__ + "static/media/j.cf4d4522.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/component/sounds/j.mp3
// module id = 99
// module chunks = 0